module.exports = __webpack_public_path__ + "img/wechat.827f3810.svg";